/*
 * HTTP authentication. POST /auth/google exchanges a Google id_token for a JWT
 * (returned in the x-auth-token header). With no real Google credentials, the
 * backend dev-fallback accepts a plain email as the token, so the existing
 * one-tap "sign in" button works against the real API too.
 */
import { ApiError } from './store'
import { apiGet, apiGoogleLogin, apiSend, getToken, setToken } from './httpClient'
import type { User } from './types'

const DEMO_EMAIL: string = import.meta.env.VITE_DEMO_EMAIL ?? 'demo@smarttravel.app'

export async function signInWithGoogleMock(idToken?: string): Promise<User> {
  const { user, token } = await apiGoogleLogin(idToken ?? DEMO_EMAIL)
  setToken(token)
  return user as User
}

export async function getSession(): Promise<User | null> {
  if (!getToken()) return null
  try {
    return await apiGet<User>('/me')
  } catch (err) {
    if (err instanceof ApiError && err.status === 401) {
      setToken(null)
      return null
    }
    throw err
  }
}

export async function signOut(): Promise<void> {
  try {
    await apiSend('POST', '/auth/logout')
  } catch {
    /* logout is best-effort; the JWT is stateless */
  }
  setToken(null)
}

export async function patchMe(patch: { language?: string }): Promise<void> {
  await apiSend('PATCH', '/me', patch)
}
